import React from 'react';
import ShopCard, { IShopCardProps } from './ShopCard';

export interface IShopListProps {
	heading?: string;
	shops?: IShopCardProps[];
}

/**
 * Shop List
 * @block
 * @icon screenoptions
 */
const ShopList: React.FC<IShopListProps> = ({ heading, shops = [] }) => {
	return (
		<div className="shop-list__container">
			<div className="shop-list__container-inner">
				{heading && <h2>{heading}</h2>}
				{shops.length > 0 && (
					<div className="shop-list__listing">
						<div className="shop-list__listing-inner">
							{shops.map((shop, index) => (
								<ShopCard key={index} {...shop} />
							))}
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default ShopList;
